import { useState, useEffect } from "react";
//  Hooks
import { useProtectedContent } from "../../hooks/useProtectedContent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import { DeliveryAddressCreate } from "./DeliveryAddressCreate";
import { DeliveryAddressSelected } from "./DeliveryAddressSelected";
import { DeliveryAddressBook } from "./DeliveryAddressBook";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const DeliveryDetails = ({ order, onConfirmAddressChange }) => {
  const [tab, setTab] = useState(0);
  const [addressConfirmed, setAddressConfirmed] = useState(false);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  // Expose addressConfirmed to parent (DraftOrder) via callback if provided
  useEffect(() => {
    if (onConfirmAddressChange) {
      onConfirmAddressChange(addressConfirmed);
    }
  }, [addressConfirmed, onConfirmAddressChange]);

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={tab}
        onChange={handleChange}
        aria-label="select address tabs"
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Delivery Address" {...a11yProps(0)} />
        <Tab label="Address Book" {...a11yProps(1)} />
        <Tab
          label="Create Address"
          {...a11yProps(2)}
          disabled={!useProtectedContent("addressCreate")}
        />
      </Tabs>
      <CustomTabPanel value={tab} index={0}>
        {/* Delivery Address with confirmation checkbox now handled in DeliveryAddressSelected */}
        <DeliveryAddressSelected
          order={order}
          setTab={setTab}
          addressConfirmed={addressConfirmed}
          onConfirmAddressChange={setAddressConfirmed}
        />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={1}>
        <DeliveryAddressBook order={order} setTab={setTab} />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={2}>
        <DeliveryAddressCreate order={order} setTab={setTab} />
      </CustomTabPanel>
    </Box>
  );
};
